<template>
    <div class="view-list">
        <div class="view-item" v-for="(item, i) in 3">
            <div class="view-head">
                <div class="view-val">{{ defaultdata[i].value2 }}</div>
                <div class="view-unit">{{ defaultdata[i].value3 }}</div>
            </div>
            <div class="view-name">{{ defaultdata[i].value1 }}</div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope130",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            defaultdata: [
                { value1: '数据一', value2: '000', value3: '单位' },
                { value1: '数据二', value2: '000', value3: '单位' },
                { value1: '数据三', value2: '000', value3: '单位' },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "数值", key: "value2" },
                { name: "单位", key: "value3" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
        },
    },
    methods: {
        ...methods
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
    },
}
</script>

<style lang="scss" scoped>
.view-list {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 435px;
    height: 240px;
    padding: 10px 0;
    .view-item {
        margin-top: 24px;
        width: 127px;
        height: 217px;
        background: url(@/assets/temimg4/gly-dz1.png) no-repeat;
        background-size: 100% 100%;
        &:nth-child(2) {
            background: url(@/assets/temimg4/gly-dz2.png) no-repeat;
            background-size: 100% 100%;
        }
        &:nth-child(3) {
            background: url(@/assets/temimg4/gly-dz3.png) no-repeat;
            background-size: 100% 100%;
        }
    }
    .view-head {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding-top: 12px;
    }
    .view-val {
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 27px;
        color: #FEFFFF;
        white-space: nowrap;
        max-width: 90px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .view-unit {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #A0B5C1;
        padding-bottom: 6px;
        padding-left: 4px;
        white-space: nowrap;
        max-width: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .view-name {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #A0B5C1;
        text-align: center;
        margin-top: 60px;
        white-space: nowrap;
        max-width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>